













import { defineComponent, PropType, ref } from '@nuxtjs/composition-api';

import { LinkAttributes } from '../../types';

export default defineComponent({
  name: 'SbLink',
  props: {
    attrs: {
      type: Object as PropType<LinkAttributes>,
      required: true,
    },
  },
  setup({ attrs }) {
    const linkType = ref(attrs.linktype);
    const href = ref(attrs.href);
    const target = ref(attrs.target);

    return {
      linkType,
      href,
      target,
    };
  },
});
